var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-broadcast-list" },
    [
      _c(
        "div",
        { staticClass: "toolbar-container" },
        [
          _c("EmailBroadcastFilterToolbar", {
            model: {
              value: _vm.filters,
              callback: function ($$v) {
                _vm.filters = $$v
              },
              expression: "filters",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar-container" }, [
        _c("div", { staticClass: "view-switcher" }, [
          _c(
            "div",
            { staticClass: "supsis-button-group" },
            [
              _c(
                "SupsisButton",
                {
                  attrs: { primary: _vm.mode === "active", small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.setMode("active")
                    },
                  },
                },
                [_vm._v(" Active")]
              ),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  attrs: { primary: _vm.mode === "archived", small: "" },
                  on: {
                    click: function ($event) {
                      return _vm.setMode("archived")
                    },
                  },
                },
                [_vm._v("\n                    Archived\n                ")]
              ),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("supsis-table", {
        attrs: {
          columns: _vm.columns,
          data: _vm.emailBroadcasts,
          loading: _vm.loading,
        },
        on: { change: _vm.onTableChange },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }